// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Rubik";
  src: url("/src/assets/fonts/Rubik-Regular.ttf");
}
.person {
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  min-height: 65vh;
  padding: 15px;
  text-align: center;
  padding-top: 170px;
  font-family: "Times New Roman", Times, serif;
}
.person .portrait {
  height: 250px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
}
.person h3 {
  font-size: 18px !important;
  margin-top: 20px;
}
.person h4 {
  font-size: 15px !important;
}
.person .flag {
  height: 48px;
  right: 10px;
  width: 65px;
  background-repeat: no-repeat;
  margin-left: auto;
  margin-right: auto;
  background-position: top center;
}
.person .prev {
  position: absolute;
  left: 15px;
  bottom: 20%;
  font-size: 60px;
  color: white;
  cursor: pointer;
  font-family: "Rubik";
  padding: 3px;
  text-shadow: 0px 5px 5px #6f6f6f;
}
.person .next {
  position: absolute;
  right: 15px;
  bottom: 20%;
  font-size: 60px;
  color: white;
  cursor: pointer;
  font-family: "Rubik";
  padding: 3px;
  text-shadow: 0px 5px 5px #6f6f6f;
}
.person .barholder div {
  display: inline-block;
  height: 10px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
}
.person .barholder .activeBar,
.person .barholder .passiveBar {
  width: 10px;
  height: 10px;
  background-color: black;
  border-radius: 7px;
  display: inline-block;
}
.person .barholder .passiveBar {
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 0;
}

@media screen and (max-width: 575px) {
  .portrait {
    height: 160px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/team-mobile-flex/team-mobile-flex.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,+CAAA;AACF;AAEA;EACE,WAAA;EACA,0CAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EAEA,4CAAA;AADF;AAKE;EACE,aAAA;EACA,wBAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;AAME;EACE,0BAAA;EACA,gBAAA;AAJJ;AAOE;EACE,0BAAA;AALJ;AAQE;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;AANJ;AASE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,gCAAA;AAPJ;AAUE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,gCAAA;AARJ;AAcI;EACE,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAZN;AAgBI;;EAEE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;AAdN;AAiBI;EACE,0CAAA;EACA,gBAAA;AAfN;;AAqBA;EACE;IACE,aAAA;EAlBF;AACF","sourcesContent":["@font-face {\r\n  font-family: 'Rubik';\r\n  src: url('/src/assets/fonts/Rubik-Regular.ttf');\r\n}\r\n\r\n.person {\r\n  width: 100%;\r\n  background-color: rgba(255, 255, 255, .8);\r\n  min-height: 65vh;\r\n  padding: 15px;\r\n  text-align: center;\r\n  padding-top: 170px;\r\n\r\n  font-family: 'Times New Roman',\r\n    Times,\r\n    serif;\r\n\r\n  .portrait {\r\n    height: 250px;\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    background-position: center center;\r\n    border-radius: 10px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }\r\n\r\n  h3 {\r\n    font-size: 18px !important;\r\n    margin-top: 20px;\r\n  }\r\n\r\n  h4 {\r\n    font-size: 15px !important;\r\n  }\r\n\r\n  .flag {\r\n    height: 48px;\r\n    right: 10px;\r\n    width: 65px;\r\n    background-repeat: no-repeat;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    background-position: top center;\r\n  }\r\n\r\n  .prev {\r\n    position: absolute;\r\n    left: 15px;\r\n    bottom: 20%;\r\n    font-size: 60px;\r\n    color: white;\r\n    cursor: pointer;\r\n    font-family: 'Rubik';\r\n    padding: 3px;\r\n    text-shadow: 0px 5px 5px #6f6f6f;\r\n  }\r\n\r\n  .next {\r\n    position: absolute;\r\n    right: 15px;\r\n    bottom: 20%;\r\n    font-size: 60px;\r\n    color: white;\r\n    cursor: pointer;\r\n    font-family: 'Rubik';\r\n    padding: 3px;\r\n    text-shadow: 0px 5px 5px #6f6f6f;\r\n  }\r\n\r\n  .barholder {\r\n\r\n\r\n    div {\r\n      display: inline-block;\r\n      height: 10px;\r\n      margin-left: auto;\r\n      margin-right: auto;\r\n      margin-top: 20px;\r\n\r\n    }\r\n\r\n    .activeBar,\r\n    .passiveBar {\r\n      width: 10px;\r\n      height: 10px;\r\n      background-color: black;\r\n      border-radius: 7px;\r\n      display: inline-block;\r\n    }\r\n\r\n    .passiveBar {\r\n      background-color: rgba(255, 255, 255, .8);\r\n      border-radius: 0;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n@media screen and (max-width:575px) {\r\n  .portrait {\r\n    height: 160px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
